import React from 'react';

// Compact AI confidence meter. value: 0..1
export default function Confidence({ value = 0, label = 'confidence', showLabel = true }) {
  const v = Math.max(0, Math.min(1, value));
  const pct = Math.round(v * 100);
  const tone =
    v >= 0.9 ? { bar: 'bg-emerald-500', text: 'text-emerald-700' }
      : v >= 0.75 ? { bar: 'bg-brand-500', text: 'text-brand-700' }
        : { bar: 'bg-amber-500', text: 'text-amber-700' };
  return (
    <div className="inline-flex items-center gap-2" title={`Model ${label}: ${pct}%`}>
      <div className="h-1.5 w-14 rounded-full bg-slate-200 overflow-hidden">
        <div className={`h-full rounded-full ${tone.bar}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={`text-[11px] font-semibold tnum ${tone.text}`}>
        {pct}%{showLabel && <span className="text-slate-400 font-normal"> {label}</span>}
      </span>
    </div>
  );
}
